import { FC } from "react";
import { Navigate, Route, Routes } from "react-router";
import { Start } from "./Start";
import { Return } from "./Return";

export const AuthenticationArea: FC = () => {
    return (
        <Routes>
            <Route index element={<Navigate to="start" replace />} />
            <Route path="return">
                <Route index path="*" element={<Return />} />
            </Route>
            <Route path="start" element={<Start />} />
        </Routes>
    );
};